export default {
  en: {
    account: {
      profile: 'My Profile',
      business: 'Business',
      subscriptions: 'Subscriptions',
      administrators: 'Administrators',
      configuration: 'Configuration',
      integration: 'Integration',
      webhooks: 'Events (Webhooks)',
      global: 'Miscellaneous',
      logout: 'Logout',
      '2fa': '2FA',
      'ip-restrictions': 'IP Restrictions',
      recordings: 'Recordings',
      abandonReasons: 'Abandon reasons',
      feedback: 'Feedback',
      utilities: 'Utilities',
      notifications: 'Notifications',
      apikeys: 'API Keys',
      referrers: 'Links',
      aiTopics: 'AI Topics',
      uploadFiles: 'Upload Files',
      sso: 'SSO',
      workingHours: 'Working hours',
      'audit-logs': 'Audit Logs',
      'forensic-audit': 'Forensic audit',
      dataInventory: 'Data classification',
      extensions: 'Extensions',
      contentBlocks: 'Content blocks',
    },
    'live-monitor': 'Live Monitor',
    monitor: 'Monitor',
    insights: 'Insights',
    users: 'Users',
    departments: 'Segments',
    integration: 'Integrations',
    forms: 'Forms',
    surveys: 'Surveys',
    marketplace: 'Marketplace',
    webhooks: 'Webhooks',
    changelog: 'Changelog',
    'user-profile': 'User profile',
    'contacts': 'Contacts',
    insightsMenu: {
      overview: 'Summary',
      indicators: 'Indicators',
      calls: 'Calls & Queues',
      departments: 'Segments',
      agents: 'Agents',
      appointments: 'Appointments',
      history: 'Call History',
      submissions: 'Submitted Forms',
      surveys: 'Surveys',
      reports: 'Reports',
      exports: 'Exports',
      abandonReasons: 'Abandon reasons',
      agentForms: 'Export agent form',
      tags: 'Tags',
      recordings: 'Recordings',
      looker: 'Custom reports',
      ai: {
        topics: 'AI Topics',
      }
    },
    insightsGroups: {
      summary: 'Summary',
      voice: 'Voice & Queues',
      agents: 'Agents',
      appointments: 'Appointments',
      surveys: 'Surveys',
      ai: 'AI',
      data: 'Reports & Data',
    },
    webhooksMenu: {
      webhooks: 'Webhooks',
      secrets: 'Secrets',
      logs: 'Logs',
    },
    tags: 'Tags',
    calendar: {
      menu: 'Calendars',
      services: 'Calendars',
      availabilities: 'Availabilities',
      appointments: 'History',
      emailTemplates: 'Email templates',
      reports: 'Reports',
    },
    branches: 'Branches',
  },
  es: {
    account: {
      profile: 'Mi Perfil',
      business: 'Empresa',
      subscriptions: 'Suscripciones',
      administrators: 'Administradores',
      configuration: 'Configuración',
      integration: 'Integración',
      webhooks: 'Eventos (Webhooks)',
      global: 'Misceláneos',
      logout: 'Cerrar sesión',
      '2fa': '2FA',
      'ip-restrictions': 'Restricciones de IP',
      recordings: 'Grabaciones',
      abandonReasons: 'Razones de abandono',
      feedback: 'Feedback',
      utilities: 'Utilidades',
      notifications: 'Notificaciones',
      apikeys: 'API Keys',
      referrers: 'Enlaces',
      aiTopics: 'Tópicos IA',
      uploadFiles: 'Subir archivos',
      sso: 'SSO',
      workingHours: 'Horas laborales',
      auditLogs: 'Registros auditables',
      'forensic-audit': 'Auditoría forense',
      dataInventory: 'Clasificación de datos',
      extensions: 'Extensiones',
      contentBlocks: 'Bloques de contenido',
    },
    'live-monitor': 'Live Monitor',
    monitor: 'Monitor',
    insights: 'Reportes',
    users: 'Usuarios',
    departments: 'Segmentos',
    integration: 'Integraciones',
    forms: 'Formularios',
    surveys: 'Encuestas',
    marketplace: 'Marketplace',
    webhooks: 'Webhooks',
    changelog: 'Novedades',
    'user-profile': 'Perfil de usuario',
    'contacts': 'Contactos',
    insightsMenu: {
      overview: 'Resumen',
      indicators: 'Indicadores',
      calls: 'Llamadas y colas',
      departments: 'Segmentos',
      agents: 'Agentes',
      appointments: 'Citas',
      history: 'Historial de llamadas',
      submissions: 'Formularios recibidos',
      surveys: 'Encuestas',
      reports: 'Reportes',
      exports: 'Exportación',
      abandonReasons: 'Razones de abandono',
      agentForms: 'Exportar formularios agente',
      tags: 'Etiquetas',
      recordings: 'Grabaciones',
      looker: 'Reportes personalizados',
      ai: {
        topics: 'Tópicos IA',
      }
    },
    insightsGroups: {
      summary: 'Resumen',
      voice: 'Voz y colas',
      agents: 'Agentes',
      appointments: 'Citas',
      surveys: 'Encuestas',
      ai: 'IA',
      data: 'Reportes y datos',
    },
    webhooksMenu: {
      webhooks: 'Webhooks',
      secrets: 'Secretos',
      logs: 'Logs',
    },
    tags: 'Etiquetas',
    calendar: {
      menu: 'Calendarios',
      services: 'Calendarios',
      availabilities: 'Disponibilidades',
      appointments: 'Historial',
      emailTemplates: 'Plantillas de emails',
      reports: 'Reportes',
    },
    branches: 'Sucursales',
  },
  fr: {
    account: {
      profile: 'Mon Profil',
      business: 'Entreprise',
      subscriptions: 'Abonnements',
      administrators: 'Administrateurs',
      configuration: 'Configuration',
      integration: 'Intégration',
      webhooks: 'Événements (Webhooks)',
      global: 'Divers',
      logout: 'Se Déconnecter',
      '2fa': '2FA',
      'ip-restrictions': 'Restrictions IP',
      recordings: 'Enregistrements',
      abandonReasons: 'Raisons d\'abandon',
      feedback: 'Retour',
      utilities: 'Utilitaires',
      notifications: 'Notifications',
      apikeys: 'Clés API',
      referrers: 'Liens',
      aiTopics: 'Sujets IA',
      uploadFiles: 'Upload Files',
      sso: 'SSO',
      workingHours: 'Heures les travaux',
      'audit-logs': 'Journaux d\'audit',
      'forensic-audit': 'Audit forensique',
      dataInventory: 'Classification des données',
      extensions: 'Extensions',
      contentBlocks: 'Blocs de contenu',
    },
    'live-monitor': 'Moniteur en Direct',
    monitor: 'Moniteur',
    insights: 'Rapports',
    users: 'Utilisateurs',
    departments: 'Segments',
    integration: 'Intégrations',
    forms: 'Formulaires',
    surveys: 'Enquêtes',
    marketplace: 'Marché',
    webhooks: 'Webhooks',
    changelog: 'Changelog',
    'user-profile': 'Profil Utilisateur',
    'contacts': 'Contacts',
    insightsMenu: {
      overview: 'Résumé',
      indicators: 'Indicateurs',
      calls: 'Appels & files',
      departments: 'Segments',
      agents: 'Agents',
      appointments: 'Rendez-vous',
      history: 'Historique des appels',
      submissions: 'Formulaires reçus',
      surveys: 'Enquêtes',
      reports: 'Rapports',
      exports: 'Exportations',
      abandonReasons: 'Raisons d\'abandon',
      agentForms: 'Exporter les formulaires agents',
      tags: 'Étiquettes',
      recordings: 'Enregistrements',
      looker: 'Rapports personnalisés',
      ai: {
        topics: 'AI Sujets',
      }
    },
    insightsGroups: {
      summary: 'Résumé',
      voice: 'Voix & files',
      agents: 'Agents',
      appointments: 'Rendez-vous',
      surveys: 'Enquêtes',
      ai: 'IA',
      data: 'Rapports & données',
    },
    webhooksMenu: {
      webhooks: 'Webhooks',
      secrets: 'Secrets',
      logs: 'Logs',
    },
    tags: 'Étiquettes',
    calendar: {
      menu: 'Calendriers',
      services: 'Calendriers',
      availabilities: 'Disponibilités',
      appointments: 'Historique',
      emailTemplates: 'Modèles d\'emails',
      reports: 'Rapports',
    },
    branches: 'Succursales',
}

};
